import AOS from '@archetype-themes/scripts/helpers/init-AOS';
import '@archetype-themes/scripts/config';
import Swatches from '@archetype-themes/scripts/modules/swatches';
import '@archetype-themes/scripts/modules/quantity-selectors'; 

class ProductGridItem extends HTMLElement {
  constructor() {
    super();

    this.swatches = new Swatches(this);

    document.dispatchEvent(new CustomEvent('product-grid-item:loaded'));

    AOS.refreshHard();

    // Refresh reviews app
    if (window.SPR) {
      SPR.initDomEls();
      SPR.loadBadges();
    }

    //Define the Selectors for Intialization of Qty Selector
    this.container = this;
    this.namespace = '.product-grid-item';
    this.initQtySelector ();
  }

  /*==============================================================================
    Qty Selector 
  ===============================================================================*/

  initQtySelector () {
    this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
      new theme.QtySelector(el, {
        namespace: this.namespace
      })
    })
  }
}

customElements.define('product-grid-item', ProductGridItem);
